import { render, staticRenderFns } from "./SearchNotFoundCard.vue?vue&type=template&id=49b69e71"
import script from "./SearchNotFoundCard.vue?vue&type=script&lang=js"
export * from "./SearchNotFoundCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports